/*
 * kult-gutschein.js — Kult-Gutschein: Betragswahl, Live-Vorschau, Empfänger-Versand, Add-to-Cart.
 * Wurzel: [data-kult-gutschein] (sections/kult-gutschein-main, sections/kult-gifts-voucher).
 * Properties wie Horizon (assets/gift-card-recipient-form.js): __shopify_send_gift_card_to_recipient,
 * Recipient email/name, Message, Send on (JJJJ-MM-TT, heute bis +90 Tage), __shopify_offset.
 * Für/Von/Grußtext immer als eigene Properties. Danach kult:cart:add (Drawer, assets/kult-cart.js).
 */
(function () {
  'use strict';
  var MAIL = /^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$/;

  function ymd(d) {
    return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
  }

  function init(root) {
    if (root.dataset.gsReady) return;
    root.dataset.gsReady = '1';
    var form = root.querySelector('[data-gs-form]');
    if (!form) return;
    var q = function (s) { return root.querySelector(s); };
    var idInput = q('[data-gs-id]');
    var fuer = q('[data-gs-fuer]'), von = q('[data-gs-von]'), gruss = q('[data-gs-gruss]');
    var count = q('[data-gs-count]'), send = q('[data-gs-send]'), box = q('[data-gs-recipient]');
    var mail = q('[data-gs-mail]'), mailError = q('[data-gs-mail-error]'), date = q('[data-gs-date]');
    var status = q('[data-gs-status]'), submit = q('[data-gs-submit]'), priceOut = q('[data-gs-price-out]');
    var pv = {
      amount: q('[data-gs-preview-amount]'), names: q('[data-gs-preview-names]'), fuer: q('[data-gs-preview-fuer]'),
      von: q('[data-gs-preview-von]'), sep: q('[data-gs-preview-sep]'), message: q('[data-gs-preview-message]')
    };

    root.querySelectorAll('[data-gs-variant]').forEach(function (pill) {
      pill.addEventListener('click', function () {
        root.querySelectorAll('[data-gs-variant]').forEach(function (p) {
          p.classList.toggle('is-active', p === pill);
          p.setAttribute('aria-pressed', p === pill ? 'true' : 'false');
        });
        idInput.value = pill.dataset.gsVariant;
        if (pv.amount) pv.amount.textContent = pill.dataset.gsAmount;
        if (priceOut) priceOut.textContent = pill.dataset.gsPrice;
      });
    });

    function preview() {
      var f = fuer.value.trim(), v = von.value.trim(), g = gruss.value.trim();
      if (pv.fuer) pv.fuer.textContent = f ? 'Für ' + f : '';
      if (pv.von) pv.von.textContent = v ? (f ? 'von ' : 'Von ') + v : '';
      if (pv.sep) pv.sep.hidden = !(f && v);
      if (pv.names) pv.names.hidden = !(f || v);
      if (pv.message) { pv.message.textContent = g ? '„' + g + '“' : ''; pv.message.hidden = !g; }
      if (count) count.textContent = gruss.value.length + ' / ' + gruss.maxLength + ' Zeichen';
    }
    [fuer, von, gruss].forEach(function (el) { el.addEventListener('input', preview); });
    preview();

    if (send) {
      send.addEventListener('change', function () {
        var on = send.checked;
        box.hidden = !on;
        send.setAttribute('aria-expanded', on ? 'true' : 'false');
        mail.disabled = !on; date.disabled = !on;
        mail.required = on;
        if (on) {
          var max = new Date(); max.setDate(max.getDate() + 90);
          date.min = ymd(new Date()); date.max = ymd(max);
          mail.focus();
        } else {
          mailError.hidden = true; mail.removeAttribute('aria-invalid');
        }
      });
    }

    function properties() {
      var p = {}, f = fuer.value.trim(), v = von.value.trim(), g = gruss.value.trim();
      if (f) p['Für'] = f;
      if (v) p['Von'] = v;
      if (g) p['Grußtext'] = g;
      if (send && send.checked) {
        p['__shopify_send_gift_card_to_recipient'] = 'on';
        p['Recipient email'] = mail.value.trim();
        if (f) p['Recipient name'] = f;
        if (g) p['Message'] = g;
        if (date.value) p['Send on'] = date.value;
        p['__shopify_offset'] = String(new Date().getTimezoneOffset());
      }
      return p;
    }

    function validate() {
      if (!send || !send.checked) return true;
      var ok = MAIL.test(mail.value.trim());
      mailError.hidden = ok;
      if (ok) mail.removeAttribute('aria-invalid'); else { mail.setAttribute('aria-invalid', 'true'); mail.focus(); }
      if (ok && date.value && (date.value < date.min || date.value > date.max)) {
        status.textContent = 'Das Versanddatum muss zwischen heute und in 90 Tagen liegen.';
        date.focus();
        return false;
      }
      return ok;
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      status.textContent = '';
      if (!validate()) return;
      submit.disabled = true; submit.classList.add('is-loading');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(idInput.value, 10), quantity: 1, properties: properties() }] })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.data.description || res.data.message || 'Fehler');
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          document.dispatchEvent(new CustomEvent('kult:cart:add', { detail: { cart: cart, title: root.dataset.gsTitle || 'Der Gutschein' } }));
        })
        .catch(function (err) { status.textContent = 'Das hat leider nicht geklappt: ' + err.message; })
        .finally(function () { submit.disabled = false; submit.classList.remove('is-loading'); });
    });
  }

  function boot() { document.querySelectorAll('[data-kult-gutschein]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
